import TutorialCard from 'components/TutorialCard';
import React from 'react';
import { useTranslation } from 'react-i18next';

import DepositStep1 from 'assets/img/deposit-qrcode-step1.png';
import DepositStep2 from 'assets/img/deposit-qrcode-step2.png';
import DepositStep3 from 'assets/img/deposit-qrcode-step3.png';
import DepositStep3_SubmitReq from 'assets/img/deposit-qrcode-step3-option1.png';
import DepositStep3_Qr from 'assets/img/deposit-qrcode-step3-option2.png';
import DepositStep4 from 'assets/img/deposit-qrcode-step4.png';
import DepositStep5 from 'assets/img/deposit-qrcode-step5.png';

const QrCode = () => {
    const { t } = useTranslation();

    const steps = [
        {
            text: t('DEPOSIT_QR_STEP_1'),
            img: DepositStep1
        },
        {
            text: t('DEPOSIT_QR_STEP_2'),
            img: DepositStep2
        },
        {
            text: t('DEPOSIT_QR_STEP_3'),
            img: DepositStep3
        },
        {
            text: t('DEPOSIT_QR_STEP_4_WALLET'),
            badge: "e-Credit",
            img: DepositStep3_SubmitReq
        },
        {
            text: t('DEPOSIT_QR_STEP_4_PLAYER'),
            badge: t('PLAYER'),
            img: DepositStep3_Qr
        },
        {
            text: t('DEPOSIT_QR_STEP_5'),
            img: DepositStep4
        },
        {
            text: t('DEPOSIT_QR_STEP_6'),
            img: DepositStep5
        }
    ]

    return (
        <div className="tutorial-list">
            {
                steps.map((step, index) => {
                    return <TutorialCard key={index} index={index + 1} {...step} />
                })
            }
        </div>
    );
};

export default QrCode;